import AnalyticsIcon from '@mui/icons-material/Analytics';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';

import { AnalyticsTopicsLink, LTVCoefficientList } from 'constants/routerPath';

import type { MenuGroup } from './types';

const analytics: MenuGroup = {
    id: 'group-analytics',
    title: 'Analytics',
    type: 'group',
    children: [
        {
            id: 'ltv-coefficient',
            title: 'LTV coefficient',
            type: 'item',
            url: LTVCoefficientList,
            icon: AutoGraphIcon,
            breadcrumbs: false,
            permission_name: 'rebill-rates',
        },
        {
            id: 'analytics-topics',
            title: 'Analytics topics',
            type: 'item',
            url: AnalyticsTopicsLink,
            icon: AnalyticsIcon,
            breadcrumbs: false,
            permission_name: 'analytics-topics',
        },
    ],
};

export default analytics;
